import { Customer_Invoices_AmountLimits } from "data/endpoints";
import IRepository from "data/IRepository";
import IExternalFilterData from "features/shared/components/dataFilter/IExternalFilterData";
import AmountLimitDTO from "features/shared/dtos/AmountLimitDTO";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { store } from "infrastructure/store/ConfigureStore";
import { injectable } from "inversify";
import { InvoiceType } from "features/invoices/enums/invoiceType";
import IInvoiceService from "./IInvoiceService";
import { getQueryParams } from "features/shared/helpers/queryParams";

@injectable()
export default class InvoiceService implements IInvoiceService {
  private readonly _invoiceAmountLimitsRepo: IRepository<AmountLimitDTO>;
    
  constructor() {
    this._invoiceAmountLimitsRepo = inversifyContainer.get<IRepository<AmountLimitDTO>>(IocTypes.Repository);
  }

  async getExternalFilterData(invoiceTypes: InvoiceType[]): Promise<IExternalFilterData<any>[]> {
    let externalFilterData: IExternalFilterData<any>[] = [];
    const customer = store.getState().customer.customer;

    // Payment Amount Limits
    const invoiceAmountLimits = await this._invoiceAmountLimitsRepo.get({
      url: Customer_Invoices_AmountLimits,
      routeParams: getRouteParams("customerId", customer.customerId!),
      params: getQueryParams("InvoiceTypes", invoiceTypes)
    });

    const currencyCodes = [
      ...new Set(invoiceAmountLimits.map((x) => x.currencyCode)),
    ];

    externalFilterData.push({
      name: "CurrencyCode",
      data: currencyCodes.map((val) => {
        return { currencyCode: val };
      }),
    });

    externalFilterData.push({
      name: "Amount",
      data: invoiceAmountLimits.filter((x) => x.limitType === "Amount"),
    });

    externalFilterData.push({
      name: "RemainToPay",
      data: invoiceAmountLimits.filter((x) => x.limitType === "Remain"),
    });

    return externalFilterData;
  }
}